import api from './api';

const API_GATEWAY_URL_PRODUCT = process.env.API_GATEWAY_URL_PRODUCT;
const API_GATEWAY_URL_CONTENT = process.env.API_GATEWAY_URL_CONTENT;

const getSalesmanListByBranch = (arg, isUseGatewayAPI?: boolean) => {
  const { branchName = '', page = 0, size = 3 } = arg || {};

  return api.get(
    `product/v1/salesman/branch/${encodeURIComponent(branchName)}?page=${page}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getSalesmanDetail = (arg, isUseGatewayAPI?: boolean) => {
  const { salesmanSlug = '' } = arg || {};
  return api.get(
    `product/v1/salesman/salesman-slug/${encodeURIComponent(salesmanSlug)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getSalesmanDetailById = (id) => {
  return api.get(`product/v1/salesman/${id}`, {}, false, false, false);
};

const getBranchDetailByNameSlug = (arg) => {
  const { salesmanSlug = '' } = arg || {};
  return api.get(
    `content/v1/branch-detail/salesman/${encodeURIComponent(salesmanSlug)}`,
    {},
    false,
    false,
    false
  );
};

const getSalesmanLayanan = (arg, isUseGatewayAPI?: boolean) => {
  const { salesmanSlug = '' } = arg || {};
  return api.get(
    `product/v1/salesman/layanan/${encodeURIComponent(salesmanSlug)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getTipsAndTrickBySalesman = (arg, isUseGatewayAPI?: boolean) => {
  const { salesmanSlug = '' } = arg || {};
  return api.get(
    `content/v1/news/salesman-slug/${encodeURIComponent(salesmanSlug)}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getNewsBySalesman = (arg, isUseGatewayAPI?: boolean) => {
  const { salesmanSlug = '', page = 0, size = 0, isLandingPage = '' } = arg || {};
  return api.get(
    `content/v1/news/salesman/${encodeURIComponent(
      salesmanSlug
    )}?page=${page}&size=${size}&isLandingPage=${isLandingPage}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_CONTENT } : {},
    false,
    false,
    false
  );
};

const getGalleryBySalesman = (arg, isUseGatewayAPI?: boolean) => {
  const { salesmanSlug = '', page = 0, size = 0, type = '' } = arg || {};
  return api.get(
    `product/v1/gallery/salesmans/${salesmanSlug}?page=${page}&size=${size}&type=${type}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getCustomerGalleryBySalesman = (arg, isUseGatewayAPI?: boolean) => {
  const { salesmanSlug = '', page = 0, size = 0, type = '' } = arg || {};
  return api.get(
    `product/v1/customer-galleries/salesmans/${salesmanSlug}?page=${page}&size=${size}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getSalesmanProposition = (arg, isUseGatewayAPI?: boolean) => {
  const { salesmanNameSlug = '' } = arg || {};
  return api.get(
    `product/v1/value-propositions/salesmans/${salesmanNameSlug}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

const getSalesmanListBranchLandingPage = (arg, isUseGatewayAPI?: boolean) => {
  const { branchName = '', page = 0, size = 5 } = arg || {};

  return api.get(
    `product/v1/salesman/branch/${branchName}?page=${page}&size=${size}&isLandingPage=${true}`,
    isUseGatewayAPI ? { baseURL: API_GATEWAY_URL_PRODUCT } : {},
    false,
    false,
    false
  );
};

export default {
  getSalesmanListByBranch,
  getSalesmanDetail,
  getSalesmanDetailById,
  getSalesmanLayanan,
  getBranchDetailByNameSlug,
  getGalleryBySalesman,
  getTipsAndTrickBySalesman,
  getNewsBySalesman,
  getSalesmanProposition,
  getCustomerGalleryBySalesman,
  getSalesmanListBranchLandingPage,
};
